import { render, staticRenderFns } from "./ExternalApps.vue?vue&type=template&id=70c02a17&"
import script from "./ExternalApps.vue?vue&type=script&lang=js&"
export * from "./ExternalApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports